export const GENDERMAN = 'mr'